import { jsx } from "react/jsx-runtime";
import { Box } from "../Box/Box.mjs";
import { ContentBlock } from "../ContentBlock/ContentBlock.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
const validPageBlockComponents = [
  "div",
  "article",
  "aside",
  "main",
  "section",
  "nav"
];
const gutters = { mobile: "small", tablet: "gutter" };
const PageBlock = ({
  children,
  width = "large",
  component: componentProp,
  data,
  ...restProps
}) => {
  const component = componentProp && validPageBlockComponents.includes(componentProp) ? componentProp : "div";
  return /* @__PURE__ */ jsx(
    Box,
    {
      component,
      paddingX: gutters,
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children: width === "full" ? children : /* @__PURE__ */ jsx(ContentBlock, { width, children })
    }
  );
};
export {
  PageBlock,
  gutters
};
